CustomTC.define('jquery/ajax/var/nonce',[
	"../../core"
], function( jQuery ) {
	return jQuery.now();
});

